/**
 * Image URL helpers. Products store images as objects: { secure_url, public_id, width, height }.
 * Legacy seed data may still hold plain string URLs — both are accepted.
 *
 * `imgUrl()` returns the renderable URL and, for Cloudinary assets, injects
 * `f_auto,q_auto` at delivery time so we never need to re-upload to gain
 * format/quality optimisation.
 */
/** Lightweight inline placeholder — used whenever a product has no image at all. */
export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23e5e7eb'/%3E%3Cpath d='M160 180a20 20 0 1 1 0 .001zm120 130H120l45-60 30 35 35-45z' fill='%239ca3af'/%3E%3C/svg%3E";

export const imgUrl = (img) => {
  const raw = typeof img === "string" ? img : (img?.secure_url || "");
  if (!raw) return "";
  if (raw.includes("/res.cloudinary.com/") && raw.includes("/upload/") && !/\/upload\/[a-z]_/.test(raw)) {
    return raw.replace("/upload/", "/upload/f_auto,q_auto/");
  }
  return raw;
};

/** Always returns a plain, non-empty string URL — the first product image if
 * present, otherwise the placeholder. Never returns null/undefined/an
 * object/an array. Use this (not imgUrl) anywhere the result gets sent to
 * the backend (cart items, order payloads), since those fields are typed
 * as plain strings and reject anything else. */
export const safeImgUrl = (images) => {
  const first = Array.isArray(images) ? images[0] : images;
  return imgUrl(first) || PLACEHOLDER_IMAGE;
};

/** Accepted file types for product image uploads. */
export const ACCEPT_IMG = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const MAX_IMG_BYTES = 10 * 1024 * 1024;
export const MAX_IMG_COUNT = 10;
